import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index'
import i18n from './plugins/i18n'
import vuetify from './plugins/vuetify'
import firebase from 'firebase/app'
import 'firebase/analytics'
import firebaseConfig from './firebaseApp/config'
import 'firebase/auth'
import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'

// TODO:: Update to false
Vue.config.productionTip = true
const firebaseApp = firebase.initializeApp(firebaseConfig)
firebaseApp.analytics()

let app = null

store.dispatch('initialState')
// vue global filter
Vue.filter('nameSnippet', function (value, size) {
  if (!value || typeof (value) !== 'string') return ''
  value = value.slice(0, size)
  if (value.length >= size) {
    value = value + '...'
  }
  return value
})

firebaseApp.auth().onAuthStateChanged(user => {
  store.dispatch('onUserChange')
  if (!app) {
    app = new Vue({
      router,
      store,
      i18n,
      vuetify,
      render: h => h(App)
    }).$mount('#app')
  }
})

if (!Vue.config.productionTip && app) {
  Sentry.init({
    dsn: 'https://4ac30ad2f60e40059efab3825e83e3d3@sentry.io/1771629',
    integrations: [new Integrations.Vue({ Vue, attachProps: true })],
    beforeSend (event, hint) {
      // Check if it is an exception, and if so, show the report dialog
      if (event.exception) {
        let errorMessage = { eventId: event.event_id }
        if (app.$i18n.locale !== 'en') {
          errorMessage = app.$i18n.t('sentry')
          errorMessage.eventId = event.event_id
        }
        Sentry.showReportDialog(errorMessage)
      }
      return event
    }

  })
}
